import _implicitStylesheets from "./typeAhead.css";
import _implicitScopedStylesheets from "./typeAhead.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _searchSuggestionOption from "search/suggestionOption";
import _searchRecentItemOption from "search/recentItemOption";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="drawer-category-title${0}"${"a0:data-item"}${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<span class="drawer-category-title${0}"${"a0:data-item"}${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<div class="backdrop${0}" data-testid="backdrop"${2}></div>`;
const stc0 = {
  "bar-container": true
};
const stc1 = {
  "role": "search"
};
const stc2 = {
  classMap: {
    "input-container": true
  },
  key: 1
};
const stc3 = {
  classMap: {
    "search-icon-container": true
  },
  attrs: {
    "aria-label": "search button"
  },
  key: 2
};
const stc4 = {
  slotAssignment: "end",
  classMap: {
    "magnifier-icon": true
  },
  props: {
    "symbol": "magnifier",
    "size": "medium",
    "fill": "#00396B"
  },
  key: 3
};
const stc5 = {
  "bar-input": true
};
const stc6 = {
  "close-icon-container": true
};
const stc7 = {
  "aria-label": "close button",
  "data-testid": "search-close-icon",
  "tabindex": "0"
};
const stc8 = {
  slotAssignment: "end",
  props: {
    "symbol": "close",
    "size": "small",
    "fill": "#0176D3"
  },
  key: 6
};
const stc9 = {
  "bar-drawer": true
};
const stc10 = {
  "data-testid": "bar-drawer"
};
const stc11 = {
  "drawer-content": true
};
const stc12 = {
  "list-option": true
};
const stc13 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element, gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, i: api_iterator, f: api_flatten} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: stc1,
    key: 0,
    on: {
      "focusout": _m0 || ($ctx._m0 = api_bind($cmp.handleContainerFocusOut))
    }
  }, [api_element("div", stc2, [api_element("div", stc3, [api_custom_element("ads-icon", _adsIcon, stc4)]), api_element("input", {
    classMap: stc5,
    attrs: {
      "type": "text",
      "name": "bar-input",
      "placeholder": $cmp.labels.searchBar,
      "title": $cmp.labels.searchBar,
      "aria-controls": api_scoped_id("search-options"),
      "role": "combobox",
      "aria-autocomplete": "list",
      "aria-activedescendant": "",
      "aria-expanded": $cmp.shouldDisplayDrawer,
      "aria-label": $cmp.labels.searchBar,
      "maxlength": $cmp.maxSearchCharLimit
    },
    props: {
      "value": $cmp.keyword
    },
    key: 4,
    on: {
      "keyup": _m1 || ($ctx._m1 = api_bind($cmp.handleInputKeyUp)),
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleInputKeyDown)),
      "focus": _m3 || ($ctx._m3 = api_bind($cmp.handleInputFocus)),
      "input": _m4 || ($ctx._m4 = api_bind($cmp.handleTextInput))
    }
  }), $cmp.keyword ? api_element("div", {
    classMap: stc6,
    attrs: stc7,
    key: 5,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleCloseIconClick)),
      "keydown": _m6 || ($ctx._m6 = api_bind($cmp.handleCloseKeyDown))
    }
  }, [api_custom_element("ads-icon", _adsIcon, stc8)]) : null]), api_element("div", {
    classMap: stc9,
    style: $cmp.shouldDisplayDrawerStyle,
    attrs: stc10,
    key: 7
  }, [api_element("div", {
    classMap: stc11,
    attrs: {
      "id": api_scoped_id("search-options"),
      "role": "listbox",
      "aria-label": "Suggestions"
    },
    key: 8
  }, api_flatten([$cmp.shouldShowSearchSuggestions ? api_flatten([api_static_fragment($fragment1, 10, [api_static_part(0, {
    attrs: {
      "data-item": $cmp.labels.terms
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.terms))]), api_custom_element("search-suggestion-option", _searchSuggestionOption, {
    classMap: stc12,
    attrs: {
      "data-testid": "suggestion-option-component",
      "data-search-value": $cmp.keywordSuggestion.suggestedKeyword,
      "data-type": "termSuggestion"
    },
    props: {
      "suggestion": $cmp.keywordSuggestion,
      "role": "option",
      "id": api_scoped_id($cmp.keywordSuggestion.suggestionId),
      "ariaSelected": "false",
      "tabIndex": "-1"
    },
    key: 11,
    on: {
      "mouseover": _m7 || ($ctx._m7 = api_bind($cmp.handleOptionMouseOver)),
      "click": _m8 || ($ctx._m8 = api_bind($cmp.handleSuggestionClick))
    }
  }), api_iterator($cmp.searchTermSuggestions, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return api_custom_element("search-suggestion-option", _searchSuggestionOption, {
      classMap: stc12,
      attrs: {
        "data-testid": "suggestion-option-component",
        "data-search-value": it.value.suggestedKeyword,
        "data-type": "termSuggestion"
      },
      props: {
        "suggestion": it.value,
        "role": "option",
        "id": api_scoped_id(it.value.suggestionId),
        "ariaSelected": "false",
        "tabIndex": "-1"
      },
      key: api_key(12, it.value.suggestedKeyword),
      on: {
        "mouseover": _m9 || ($ctx._m9 = api_bind($cmp.handleOptionMouseOver)),
        "click": _m10 || ($ctx._m10 = api_bind($cmp.handleSuggestionClick))
      }
    });
  })]) : stc13, $cmp.shouldShowRecentItems ? api_flatten([api_static_fragment($fragment2, 14, [api_static_part(0, {
    attrs: {
      "data-item": $cmp.labels.recentItems
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.labels.recentItems))]), api_iterator($cmp.recentItems, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return api_custom_element("search-recent-item-option", _searchRecentItemOption, {
      classMap: stc12,
      attrs: {
        "data-testid": "recent-item-option-component",
        "data-search-value": it.value.listing.oafId,
        "data-type": "recentItem"
      },
      props: {
        "recentItem": it.value,
        "role": "option",
        "id": api_scoped_id(it.value.recentItemId),
        "tabIndex": "-1"
      },
      key: api_key(15, it.value.listing.oafId),
      on: {
        "mouseover": _m11 || ($ctx._m11 = api_bind($cmp.handleOptionMouseOver)),
        "click": _m12 || ($ctx._m12 = api_bind($cmp.handleRecentItemClick))
      }
    });
  })]) : stc13]))])]), $cmp.shouldDisplayDrawer ? api_static_fragment($fragment3, 17, [api_static_part(0, {
    on: {
      "click": _m15 || ($ctx._m15 = api_bind($cmp.handleBackdropClick)),
      "mouseover": _m16 || ($ctx._m16 = api_bind($cmp.handleBackdropMouseOver))
    }
  }, null)]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4vp89uu3er4";
tmpl.legacyStylesheetToken = "undefined-_typeAhead";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
